import Navbar from "../navbar/Navbar";
import { useSelector } from "react-redux";
import SideMenu from "../../components/eventLayout/SideMenu";
import DemoEventBar from "../../components/eventLayout/DemoEventBar";
import EventLayout from "../../components/eventLayout/EventLayout";
import { useMatch } from "react-router-dom";
import RegForm from "../../components/eventLayout/settings/RegForm/RegForm";
import LinkedinAutoPost from "../../components/eventLayout/communications/marketing/LinkedinAutoPost";
import EmailMarketing from "../../components/eventLayout/communications/emailMarketing/EmailMarketing";
import StaffManagement from "../../components/eventLayout/settings/staffManagement/StaffManagement";
// import Ticketing from "../../components/eventLayout/settings/ticketing/EventTickets";
import WhatsAppMarketing from "../../components/eventLayout/communications/whatsAppMarketing/WhatsAppMarketing";
import Mailchimp from "../../components/eventLayout/communications/plugins/Mailchimp";
import EmailDomainWhitelable from "../../components/eventLayout/communications/plugins/sendgridDomainWhitelable/EmailDomainWhitelable";
import BadgeTemplate from "../../components/eventLayout/settings/badgeTemplate/BadgeTemplate";

import TicketTemplate from "../../components/eventLayout/settings/ticketTemplate/ticketTemplate";
import TicketAnalytics from "../../components/eventLayout/settings/ticketing/TicketAnalytics";
import Ticketing from "../../components/eventLayout/settings/ticketing/Ticketing";
import ExhibitorDirectory from "../../components/eventLayout/communications/exhibitorDirectory/ExhibitorDirectory";
import EmailNotifications from "../../components/eventLayout/communications/notifications/emailNotifications/EmailNotifications";

const EventHomeLayout = () => {
  const formBuilder = useMatch("/events/:eventId/settings/formbuilder");
  const LinkedinPost = useMatch(
    "/events/:eventId/communications/linkedin-marketing"
  );
  const emailMarketing = useMatch(
    "/events/:eventId/communications/eventMarketing"
  );
  const staffManagement = useMatch(
    "/events/:eventId/settings/staff-management"
  );
  const ticketing = useMatch("/events/:eventId/settings/ticketing");

  const whatsAppMarketing = useMatch(
    "/events/:eventId/communications/whatsapp-marketing"
  );
  const ticketTemplate = useMatch("/events/:eventId/settings/ticket-templates");

  const mailChimp = useMatch("/events/:eventId/communications/mail-chimp");

  const emailDomainWhitelable = useMatch(
    "/events/:eventId/communications/email-domain-whitelable"
  );

  const badgeTemplate = useMatch("/events/:eventId/settings/badge-templates");

  const exhibitorDirectory = useMatch(
    "/events/:eventId/communications/exhibitorDirectory"
  );

  const emailNotifications = useMatch(
    "/events/:eventId/communications/emailNotifications"
  );

  const singleEvent = useSelector((state) => state.eventData);
  return (
    <div className="flex flex-col">
      {singleEvent.isMockEvent && (
        <div className="header h-10 w-full">
          <DemoEventBar />
        </div>
      )} 
      <div className="header h-[58px] w-full">
        <Navbar />
      </div>
      <div className="w-full flex justify-center items-center flex-col ">
        <div className="w-full overflow-x-hidden">
          <div
            className={`grid grid-cols-[228px_1fr] ${
              singleEvent.isMockEvent
                ? "h-[calc(100vh_-_98px)]"
                : " h-[calc(100vh_-_58px)]"
            }  `}
          >
            {/* <div className="sidebar md:w-[228px]"> */}
            <div className="sidebar md:w-[228px]">
              <SideMenu
                eventTitle={singleEvent?.title}
                organizer={singleEvent?.primaryOrganizer?.firstName}
              />
            </div>
            <div
              className={`container ml-[30px] w-full ${
                singleEvent.isMockEvent
                  ? "h-[calc(100vh_-_98px)]"
                  : " h-[calc(100vh_-_58px)]"
              }`}
            >
              {formBuilder ? (
                <RegForm />
              ) : LinkedinPost ? (
                <LinkedinAutoPost />
              ) : emailMarketing ? (
                <EmailMarketing />
              ) : staffManagement ? (
                <StaffManagement />
              ) : ticketing ? (
                <Ticketing />
              ) : whatsAppMarketing ? (
                <WhatsAppMarketing />
              ) : mailChimp ? (
                <Mailchimp />
              ) : emailDomainWhitelable ? (
                <EmailDomainWhitelable />
              ) : badgeTemplate ? (
                <BadgeTemplate />
              ) : exhibitorDirectory ? (
                <ExhibitorDirectory />
              ) : ticketTemplate ? (
                <TicketTemplate />
              ) : emailNotifications ? (
                <EmailNotifications />
              ) : (
                <EventLayout />
              )}

              {/* {props.children} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventHomeLayout;
